import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams, Link} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { BrowserMultiFormatReader } from '@zxing/library';
import QRCode from 'react-qr-code';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faComment, faEdit, faCamera, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './DocSure.css';
import { logout } from "../../redux/actions/authActions";

const DocSureCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("MediFinders");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };


  const [documentCode, setDocumentCode] = useState('');
  const [documentDetails, setDocumentDetails] = useState(null);
  const [error, setError] = useState('');
  const [belongsToOther, setBelongsToOther] = useState(false);
  const [belongsToMe, setBelongsToMe] = useState(false);
  const [scannedDocumentCode, setScannedDocumentCode] = useState('');
  const [scanResult, setScanResult] = useState('');
  const [scanning, setScanning] = useState(false);
  const videoRef = useRef(null);
  const [qrCodeData, setQrCodeData] = useState('');

  const [userDetails, setUserDetails] = useState({
    userId: '',
    userName: '',
    city: '',
    pin: '',
  });

  const [newDocumentDetails, setNewDocumentDetails] = useState({
    documentName: '',
    shopName: '',
    shopAddress: '',
    city: '',
    pin: '',
    datePurchase: '',
    comment: '',
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setDocumentCode(e.target.value);
  };

  const handleUserDetailsChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleNewDocumentDetailsChange = (e) => {
    const { name, value } = e.target;
    setNewDocumentDetails({ ...newDocumentDetails, [name]: value });
  };

  const handleCheckDocument = async (e) => {
    e.preventDefault();
    
    if (!documentCode.trim()) {
      setError('Document code cannot be blank.');
      return;
    }
    
    try {
      const config = { 
        url: `/docsurebank/getdocument`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { documentCode }
      };
  
      const response = await fetchData(config, { showSuccessToast: false });
      // console.log("Search response ", response);
  
      if (!response.status) {
        setError(response.message || "Error fetching document data.");
        setDocumentDetails(null);
        setBelongsToOther(false);
        setBelongsToMe(false);
      } else {
        const { entry } = response;
        setDocumentDetails(entry);
  
        if (entry.scannedName) {
          if (entry.scannedName === authState.user.name) {
            setError("As per docSure Database, this Document already belongs to You");
            setBelongsToMe(true);
            setBelongsToOther(false);
          } else {
            setError("As per docSure database, this Document belongs to Somebody else");
            setBelongsToOther(true);
            setBelongsToMe(false);
          }
        } else {
          setError('');
          setBelongsToOther(false);
          setBelongsToMe(false);
        }
        
        setMessage('');
      }
    } catch (error) {
      console.error("Error fetching docSure data:", error);
      setError("Error fetching docSure data");
      setBelongsToOther(false);
      setBelongsToMe(false);
    }
  };

  const handleUpdateBesureBank = (e) => {
    e.preventDefault();
    // Add your logic to update the document in docSureBank here
  };

  const handleAddBesureFake = (e) => {
    e.preventDefault();
    // Add your logic to add the document to docSureFake here
  };

  const handleBackToHome = () => {
    navigate('/docsure-home');
  };

  const handleScan = (result) => {
    if (result) {
      setScanResult(result);
      setScanning(false);
    }
  };

  const handleError = (error) => {
    console.error(error);
    setScanning(false);
  };

  // const startScanning = () => {
  //   const codeReader = new BrowserMultiFormatReader();
  //   codeReader
  //     .decodeFromVideoDevice(null, videoRef.current, (result, error) => {
  //       if (result) {
  //         handleScan(result.text);
  //       }
  //       if (error) {
  //         handleError(error);
  //       }
  //     });
  // };

  // useEffect(() => {
  //   let codeReader;

  //   const startScanning = async () => {
  //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //       codeReader = new BrowserMultiFormatReader();
  //       try {
  //         const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
  //         videoRef.current.srcObject = stream;
  //         codeReader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
  //           if (result) {
  //             setQrCodeData(result.text);
  //             setScanning(false);
  //             if (videoRef.current.srcObject) {
  //               const tracks = videoRef.current.srcObject.getTracks();
  //               tracks.forEach(track => track.stop());
  //             }
  //           }
  //           if (err && !(err instanceof NotFoundException)) {
  //             console.error(err);
  //           }
  //         });
  //       } catch (error) {
  //         console.error('Error accessing media devices.', error);
  //         setScanning(false);
  //       }
  //     } else {
  //       console.error('getUserMedia not supported by this browser.');
  //       setScanning(false);
  //     }
  //   };

  //   if (scanning) {
  //     startScanning();
  //   }

  //   return () => {
  //     if (codeReader) {
  //       codeReader.reset();
  //     }
  //     if (videoRef.current && videoRef.current.srcObject) {
  //       const tracks = videoRef.current.srcObject.getTracks();
  //       tracks.forEach(track => track.stop());
  //     }
  //   };
  // }, [scanning]);

  useEffect(() => {
    let codeReader;

    const startScanning = async () => {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        codeReader = new BrowserMultiFormatReader();
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
          videoRef.current.srcObject = stream;
          codeReader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
            if (result) {
              setQrCodeData(result.text);
              setScanning(false);
              if (videoRef.current.srcObject) {
                const tracks = videoRef.current.srcObject.getTracks();
                tracks.forEach(track => track.stop());
              }
            }
            if (err && !(err instanceof NotFoundException)) {
              console.error(err);
            }
          });
        } catch (error) {
          console.error('Error accessing media devices.', error);
          setScanning(false);
        }
      } else {
        console.error('getUserMedia not supported by this browser.');
        setScanning(false);
      }
    };

    if (scanning) {
      startScanning();
    }

    return () => {
      if (codeReader) {
        codeReader.reset();
      }
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, [scanning]);


  return (
     <div className='bg-black text-white [&_p]:text-white p-2'>
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">📑🛡️ DocSure</div>
          <div className="text-xs text-white">हमेशा docSure@Think5Whys से पूछो!</div>          
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      
      {/* <div>
        <h2 className='text-lg mx-2 text-white'>DocSure - Check Document</h2>
      </div> */}
      <div className="min-h-[75vh] m-auto my-2 p-2 shadow-md rounded-md">
        <form onSubmit={handleCheckDocument}>
          <div className='p-2 border-2 shadow-md rounded-md mb-4'>
            <div className='flex flex-col items-center mt-2 px-4'>
              <label className='text-lg lg:text-xl font-medium text-orange-300 text-center'>
                DocSure - Check Document 
              </label>
            </div>
            <div className='mt-2 mb-2 flex flex-col items-center justify-center'>
              <div className='flex flex-row'>
                <i className="fas fa-barcode text-yellow-200 text-5xl mb-2 ml-2 mr-2"></i>
                <i className="fas fa-keyboard text-white text-5xl mb-2 ml-2 mr-2"></i>
                <i className="fas fa-qrcode text-orange-300 text-5xl mb-2 ml-2 mr-2" ></i>
              </div>
              <div className='flex flex-col items-center mr-4'>
                <label className='text-lg font-medium text-white'>Document Code:</label>
              </div>
              <input
                type="text"
                name="documentCode"
                value={documentCode}
                onChange={handleInputChange}
                className='w-full max-w-md p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300 text-center'
                />
            </div>
            {error && !belongsToMe && (
              <div className='text-red-300 text-center text-lg mb-4'>
                <i class="fas fa-exclamation-triangle text-yellow-200 text-5xl"></i>
                <p>{error}</p>
              </div>
            )}
            <div className='flex flex-row justify-center mb-4'>
              <button className="w-40 lg:w-48 text-xs lg:text-sm bg-blue-600 rounded-md" type="submit" onClick={handleCheckDocument}>
                  Check My Document
              </button>
              <button className="w-40 lg:wp48 text-xs lg:text-sm ml-4 bg-blue-600" onClick={handleBackToHome}>Back to Home</button>
            </div>
          
            <div className='flex flex-col justify-center'>
              <div className='flex flex-row justify-center'>
                <button
                  className='w-40 lg:w-48 text-xs lg:text-sm bg-blue-600 rounded-md'
                  onClick={() => setScanning(true)}
                  disabled={scanning}
                >
                  <FontAwesomeIcon icon={faCamera} /> Scan QR Code
                </button>
                {/* <button
                  className='btn btn-generate ml-2 w-full'
                  onClick={() => setDocumentCode('')}
                >
                  <FontAwesomeIcon icon={faQrcode} /> Generate QR Code
                </button> */}
              </div>
              {scanning ? (
                <div className='scanner'>
                  <video ref={videoRef} style={{ width: '100%' }} autoPlay />
                </div>
              ) : (
                <div className='flex flex-row justify-center '>
                  <p className='text-lg text-yellow-200 flex items-center'>QR Code Scanning Not Supported By Your Browser</p>
                </div>
              )}

              {qrCodeData && (
                <div className='qr-code-data'>
                  <h3 className='text-lg font-medium text-white'>Scanned QR Code Data:</h3>
                  <p className='text-gray-300'>{qrCodeData}</p>
                </div>
              )}
              {/* <div className='flex flex-col justify-center'>
                <h3 className='text-lg font-medium text-white'>Generate QR Code:</h3>
                <QRCode value={documentCode} />
              </div> */}
            </div>
          </div>
        </form>
        {documentDetails && !belongsToOther && (
          <div className='p-6 bg-gray-800 text-white rounded-md shadow-md'>
          <div className='flex items-center justify-center mb-4'>
            <h2 className='text-2xl font-bold text-blue-400'>Document Details</h2>
          </div>
          <div className='flex flex-col items-center mt-8 px-4'>
              <i className="fas fa-check-circle text-green-400 text-5xl"></i>
              <label className='text-2xl md:text-3xl font-medium text-orange-300 text-center'>
                  docSure@Think5Whys Authenticated
              </label>
            </div>
          {belongsToMe && (
            <div className='flex items-center flex-col justify-center mb-4'>
              <i className="fas fa-thumbs-up text-green-500"></i>
              <h2 className='text-2xl font-bold text-green-400'>{authState.user.name}</h2>
          </div>
          )}
        
          <div className='mb-6'>
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <p className='text-lg font-semibold'>Document Name:</p>
                <p className='text-gray-300'>{documentDetails.documentName}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Document Brief:</p>
                <p className='text-gray-300'>{documentDetails.documentBrief}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Brand Name:</p>
                <p className='text-gray-300'>{documentDetails.documentBrand}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Manufacturing Date:</p>
                <p className='text-gray-300'>{new Date(documentDetails.mfgDate).toLocaleDateString()}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Expiry Date:</p>
                <p className='text-gray-300'>{new Date(documentDetails.expDate).toLocaleDateString()}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Batch Number:</p>
                <p className='text-gray-300'>{documentDetails.batchNumber}</p>
              </div>
            </div>
          </div>
        
          {/* <form onSubmit={handleUpdateBesureBank} className='space-y-4'>
            <div>
              <label className='block text-sm font-medium text-gray-400'>User ID:</label>
              <input type="text" name="userId" value={userDetails.userId} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>User Name:</label>
              <input type="text" name="userName" value={userDetails.userName} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>City:</label>
              <input type="text" name="city" value={userDetails.city} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>PIN:</label>
              <input type="text" name="pin" value={userDetails.pin} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <button type="submit" className='w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md'>Update Document</button>
          </form> */}
        </div>
        )}
        {message && !documentDetails && (
          <div className='text-sm text-black p-6 border-2 shadow-md rounded-md'>
            <p className='flex justify-center text-lg text-red-300 mb-4'>{message}</p>
            <form onSubmit={handleAddBesureFake} className='space-y-4'>
              <div className='flex items-center'>
                <label className='w-1/4 pr-4'>Document Name:</label>
                <input
                  type='text'
                  name='documentName'
                  value={newDocumentDetails.documentName}
                  onChange={handleNewDocumentDetailsChange}
                  style={{ width: "400px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Shop Name:</label>
                <input
                  type='text'
                  name='shopName'
                  value={newDocumentDetails.shopName}
                  onChange={handleNewDocumentDetailsChange}
                  style={{ width: "400px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Shop Address:</label>
                <textarea
                  type='text'
                  name='shopAddress'
                  value={newDocumentDetails.shopAddress}
                  onChange={handleNewDocumentDetailsChange}
                  className='p-2 border border-gray-700 rounded'
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    maxWidth: '650px', 
                    maxHeight: '150px' 
                  }}
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>City:</label>
                <input
                  type='text'
                  name='city'
                  value={newDocumentDetails.city}
                  onChange={handleNewDocumentDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>PIN:</label>
                <input
                  type='text'
                  name='pin'
                  value={newDocumentDetails.pin}
                  onChange={handleNewDocumentDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Date of Purchase:</label>
                <input
                  type='date'
                  name='datePurchase'
                  value={newDocumentDetails.datePurchase}
                  onChange={handleNewDocumentDetailsChange}
                  style={{ width: "100px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Comment:</label>
                <textarea
                  type='text'
                  name='comment'
                  value={newDocumentDetails.comment}
                  onChange={handleNewDocumentDetailsChange}
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    maxWidth: '650px', 
                    maxHeight: '150px' 
                  }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User ID:</label>
                <input
                  type='text'
                  name='userId'
                  value={userDetails.userId}
                  onChange={handleUserDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User Name:</label>
                <input
                  type='text'
                  name='userName'
                  value={userDetails.userName}
                  onChange={handleUserDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User City:</label>
                <input
                  type='text'
                  name='city'
                  value={userDetails.city}
                  onChange={handleUserDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User PIN:</label>
                <input
                  type='text'
                  name='pin'
                  value={userDetails.pin}
                  onChange={handleUserDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex justify-center'>
                <button
                  type='submit'
                  className='mt-4 px-4 py-2 w-40 lg:w-48  text-xs lg:text-sm bg-blue-600 text-white rounded hover:bg-blue-700'
                >
                  Add to docSureFake
                </button>
              </div>
          </form>
        </div>
        )}
        {/* <button onClick={handleBackToHome}>Back to Home</button> */}
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-1 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
};

export default DocSureCreate;
